export const BulbIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_244_6319)">
        <path
          d="M7.33336 15.4326V18H12.6667V15.5433C12.6536 14.975 12.7617 14.4105 12.9838 13.8872C13.2059 13.364 13.5369 12.894 13.9547 12.5086C14.8666 11.7093 15.5149 10.6524 15.8142 9.47729C16.1135 8.30214 16.0496 7.0639 15.6311 5.92576C15.2126 4.78762 14.459 3.80301 13.4697 3.10171C12.4804 2.40041 11.3018 2.01534 10.0893 1.99725C8.87678 1.97916 7.68724 2.3289 6.67746 3.00037C5.66768 3.67184 4.88506 4.63353 4.43276 5.75867C3.98046 6.88382 3.87971 8.11961 4.14378 9.30316C4.40785 10.4867 5.02435 11.5625 5.91203 12.3886C6.34683 12.7699 6.69768 13.2374 6.94235 13.7614C7.18702 14.2854 7.32017 14.8545 7.33336 15.4326V15.4326ZM11.3334 16.6666H8.6667V15.4326C8.6667 15.3993 8.66203 15.366 8.66136 15.3333H11.344C11.344 15.4033 11.3334 15.4726 11.3334 15.5433V16.6666ZM5.37336 7.38331C5.47247 6.63543 5.75142 5.92273 6.1863 5.30627C6.62119 4.68981 7.19904 4.18797 7.87036 3.84376C8.54168 3.49954 9.28644 3.32322 10.0408 3.32988C10.7952 3.33655 11.5367 3.52601 12.2019 3.88204C12.867 4.23806 13.4359 4.75003 13.8598 5.37408C14.2837 5.99813 14.55 6.71566 14.6359 7.46517C14.7218 8.21469 14.6247 8.97385 14.3529 9.67761C14.0811 10.3814 13.6427 11.0087 13.0754 11.506C12.3334 12.1703 11.802 13.0373 11.5467 14H10.6667V9.21065C11.0553 9.07326 11.392 8.81916 11.6306 8.48311C11.8693 8.14707 11.9983 7.74549 12 7.33331H10.6667C10.6667 7.51012 10.5965 7.67969 10.4714 7.80472C10.3464 7.92974 10.1768 7.99998 10 7.99998C9.82322 7.99998 9.65365 7.92974 9.52862 7.80472C9.4036 7.67969 9.33336 7.51012 9.33336 7.33331H8.00003C8.00174 7.74549 8.13075 8.14707 8.36942 8.48311C8.60809 8.81916 8.94476 9.07326 9.33336 9.21065V14H8.45203C8.15136 13.0061 7.58744 12.1121 6.82003 11.4126C6.27305 10.9065 5.85602 10.2762 5.60421 9.5748C5.3524 8.87344 5.27322 8.12175 5.37336 7.38331V7.38331Z"
          fill="#706A85"
        />
      </g>
      <defs>
        <clipPath id="clip0_244_6319">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
